const INIT_STATE = {
  isLoaderCount: 0,
  selectedService: {},
  modules: [],
  selectedCorporate: null,
  selectedNotification: [],
};


export default (state = INIT_STATE, action) => {

  switch (action.type) {

    case "TOGGLE_STATE": {
      return {
        ...state,
        toggle: action.payload
      };
    }
    case "CHANGE_VIEW": {
      return {
        ...state,
        view: action.payload
      };
    }
    case "CHANGE_PASSWORD": {
      return {
        ...state,
        isChangePasswordVisible: action.payload
      };
    }
    case "CONFIRMATION_DIALOG": {
      return {
        ...state,
        confirmationDialog: action.payload
      };
    }
    case "TIME_PICKER": {
      return {
        ...state,
        timePicker: action.payload
      };
    }
    case "TOGGLE_LOADER": {
      var counter = state.isLoaderCount;
      if (action.payload) {
        counter++;
      } else {
        counter--;
      }
      if (counter <= 0) {
        return {
          ...state,
          isLoaderCount: 0,
          isLoading: false
        };
      } else {
        return {
          ...state,
          isLoaderCount: counter,
          isLoading: true
        };
      }
      // return {
      //   ...state,
      //   isLoading: action.payload
      // };
    }

    case "TOGGLE_LOADER_CLEAR": {
      console.log("clear")
      return {
        ...state,
        isLoaderCount: 0,
        isLoading: false
      };
    }
    case "SERVICE_LIST": {
      return {
        ...state,
        modules: action.payload
      };
    }

    case "SELECTED_SERVICE": {
      return {
        ...state,
        selectedService: action.payload
      };
    }
    case "SELECTED_CORPORATE": {
      return {
        ...state,
        selectedCorporate: action.payload
      };
    }
    case "TOGGLE_LOADER_MULTI": {
      var count = state.isLoadingCount;
      if (action.payload) {
        count++;
      } else {
        count--;
      }
      if (count <= 0) {
        return {
          ...state,
          isLoadingCount: 0,
          isLoading: false
        };
      } else {
        return {
          ...state,
          isLoadingCount: count,
          isLoading: true
        };
      }

    }
    case "SELECTED_NOTIFICATION": {
      return {
        ...state,
        selectedNotification: action.payload
      };
    }

    default :
      return state;

  }
}

